export const formatPhone = (value) => {
  if (!value) return '';
  const newNumber = value.replace(/\D/g, '');
  return newNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const handlePhoneFormat = (value) => {
  if (!value) return '';
  const newNumber = value.replace(/\D/g, '');
  return newNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
};

export function mergeSmsAndPhoneData(smsData, phoneData) {
  return {
    data: {
      subscriptions: [
        ...(smsData?.data?.subscriptions || []),
        ...(phoneData?.data?.subscriptions?.[0]?.subscriptions?.subscription || []),
      ]
    }
  };
}
